import React, { useRef } from 'react';
import useSeo from '../lib/seo';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { PROJECTS } from '../data/portfolio';

gsap.registerPlugin(useGSAP);

const EG = PROJECTS.find((p) => p.slug === 'eg-treinos');

/**
 * EG Treinos: a apresentação completa ainda está sendo preparada.
 * A página mostra o produto com o que já é público, sem inventar recursos.
 */
function EgTreinos() {
  const root = useRef(null);

  useSeo({
    title: 'EG Treinos | Idealizer',
    description: 'EG Treinos: app para personal trainers organizarem a agenda e entregarem os treinos de cada aluno. Projeto da Idealizer.',
    path: '/apps/eg-treinos',
  });

  useGSAP(
    () => {
      const q = gsap.utils.selector(root);
      const mm = gsap.matchMedia();
      mm.add('(prefers-reduced-motion: no-preference)', () => {
        gsap
          .timeline({ delay: 0.15 })
          .fromTo(q('.pg-rise'), { y: 0, yPercent: 115 }, { yPercent: 0, duration: 1.2, ease: 'expo.out', stagger: 0.08 })
          .fromTo(q('.pg-fade'), { autoAlpha: 0, y: 18 }, { autoAlpha: 1, y: 0, duration: 1, ease: 'expo.out', stagger: 0.08 }, 0.4)
          .fromTo(q('.eg-phone'), { yPercent: 30, rotate: 8, autoAlpha: 0 }, { yPercent: 0, rotate: -4, autoAlpha: 1, duration: 1.4, ease: 'expo.out' }, 0.2)
          .fromTo(q('.eg-glow'), { scale: 0.6, autoAlpha: 0 }, { scale: 1, autoAlpha: 1, duration: 1.6, ease: 'expo.out' }, 0.2);
        // Respiração lenta do brilho atrás do celular.
        gsap.to(q('.eg-glow'), { scale: 1.08, duration: 3.2, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 1.8 });
      });
      return () => mm.revert();
    },
    { scope: root }
  );

  return (
    <main className="pg eg-v3" ref={root} style={{ '--accent': EG.accent }}>
      <section className="container eg-hero">
        <div className="eg-copy">
          <Link to="/nosso-trabalho" className="pg-back pg-fade">
            <ArrowLeft size={16} strokeWidth={2} aria-hidden /> Nosso trabalho
          </Link>
          <h1 className="pg-title eg-title">
            <span className="pg-line">
              <span className="pg-rise">EG</span>
            </span>
            <span className="pg-line">
              <span className="pg-rise">Treinos</span>
            </span>
          </h1>
          <p className="eg-tagline pg-fade">{EG.tagline}</p>
          <p className="pg-lede pg-fade">{EG.desc}</p>
          <ul className="eg-tags pg-fade" aria-label="Plataformas">
            {EG.platforms.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
          <p className="eg-soon pg-fade">
            <span className="eg-soon-dot" aria-hidden />
            Apresentação completa em breve.
          </p>
        </div>

        <div className="eg-stage" aria-hidden>
          <div className="eg-glow" />
          <div className="hv3-phone eg-phone">
            <div className="hv3-phone-screen">
              <img src={EG.screen} alt="" width="600" height="1300" decoding="async" />
            </div>
            <span className="hv3-phone-island" />
          </div>
        </div>
      </section>

      <section className="container pg-cta">
        <div className="cta-card">
          <div className="cta-glow" aria-hidden />
          <h2 className="cta-title">Quer um app para o seu negócio?</h2>
          <p className="cta-sub">
            Do agendamento à entrega de conteúdo para cada cliente, desenhamos e desenvolvemos o produto completo.
          </p>
          <div className="cta-actions">
            <Link to="/contato" className="btn-primary">
              Começar um projeto <ArrowRight size={18} strokeWidth={2} aria-hidden />
            </Link>
            <Link to="/nosso-trabalho" className="btn-ghost">
              Ver outros projetos
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}

export default EgTreinos;
